import { getItem, removeItem, setItem } from "../storage-data";

const SESSION_PRINT_HOUSE_ID_KEY = "session-print-house-id";

export const getSessionPrintHouseId = (): string | undefined => {
  const value = getItem(SESSION_PRINT_HOUSE_ID_KEY);
  if (typeof value !== "string" || !value.trim()) {
    return undefined;
  }
  return value.trim();
};

export const setSessionPrintHouseId = (printHouseId: string | undefined): void => {
  if (!printHouseId || !String(printHouseId).trim()) {
    removeItem(SESSION_PRINT_HOUSE_ID_KEY);
    return;
  }
  setItem(SESSION_PRINT_HOUSE_ID_KEY, String(printHouseId).trim());
};

export const clearSessionPrintHouseId = (): void => {
  removeItem(SESSION_PRINT_HOUSE_ID_KEY);
};
